<template>
  <div>
    <print ref="print" class="print" :use-manifest="false">
      <div class="overflow-hidden">
        <img class="fl" src="../../../../assets/other/logo.png" alt="" height="100">
        <b class="fr" style="line-height: 100px">注：服药前请核对姓名，电话，医生等信息以及服用方法、医嘱等</b>
      </div>
      <div class="pt5">订单日期：{{ info.createTime|timeFormat('%Y年%m月%d日') }}</div>
      <table>
        <tr>
          <td>姓名：{{ info.compatName }}</td>
          <td>性别：{{ info._sex }}</td>
          <td>年龄：{{ info.compatAge }}</td>
          <td>电话：{{ info.compatMobile }}</td>
          <td>处方编号：{{ info.orderNo }}</td>
        </tr>
        <tr>
          <td colspan="5">收件地址：{{ onlineShipping.shippingAddress }}</td>
        </tr>
        <tr>
          <td colspan="5">临床诊断：{{ info.diagnosis }}</td>
        </tr>
      </table>
      <div class="pt10">
        <h3>Rp.</h3>
        <template v-if="info.orderType==='WESTERN_RECIPE'">
          <ul v-for="(d,i) in info.drugList" :key="i" class="pt5 pb5">
            <li>{{ d.drugName }} {{ d.drugSpecification }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;X{{
                d.amount
              }}{{ d.drugUnit }}
            </li>
            <li>用法用量：{{ d.admission }}，{{ d.frequencyName }}，每次{{ d.dosage }}{{ d.dosageUnit }}
              {{ d.useDays ? '，用药' + d.useDays + '天' : '' }}
            </li>
          </ul>
        </template>
        <template v-else>
          <ul v-for="(d,i) in info.drugList" :key="i" class="pt5 pb5">
            <li>{{ d.drugName || d.ypmc }} {{ d.amount || d.dosage }}{{ d.jldw || d.dosageUnit }}</li>
          </ul>
          <div>用法用量：{{ info.tcmAdmission }}，共{{ drugList.length }}味药，{{ info.tcmDosage }}付</div>
        </template>
      </div>

      <table class="mt20">
        <tr>
          <td>医师</td>
          <td>{{ info.docName }}</td>
          <td>初审</td>
          <td>{{ info.auditorName }}</td>
          <td>复审</td>
          <td>{{ info.pharmacistName }}</td>
          <td>发药</td>
          <td>{{ docInfo.docName }}</td>
          <td>类型</td>
          <td>{{ RECIPE_TYPE[info.orderType] }}</td>
          <td>金额</td>
          <td>{{ info.totalPrice / 100 }}</td>
        </tr>
        <tr>
          <td colspan="2">配送单位</td>
          <td colspan="10">{{ info.hosName }}</td>
        </tr>
      </table>
      <div class="overflow-hidden pt20">
        <ul class="fl fs14">
          <li>客服电话：400-005-0075</li>
          <li>工作时间：8:30-18:00</li>
        </ul>
        <div class="fr overflow-hidden">
          <img src="../../../../assets/other/ercode.jpg" alt="" class="fl" height="100">
          <div class="fl fs12 pt50">
            <p>扫一扫</p>
            <p>随时咨询医生</p>
          </div>
        </div>
      </div>
    </print>
    <p class="pl20 flex flex0 aic">
      <el-button size="mini" type="primary" @click="print">打印</el-button>
      <el-button size="mini" type="success" @click="dl">下载/打印PDF</el-button>
    </p>
  </div>
</template>

<script>
import {recipeService} from "@/lib/service/recipe";
import {timeFormat} from "@/lib/utils";
import {RECIPE_TYPE} from "@/lib/config";

export default {
  name: "shd",
  filters: {
    timeFormat
  },
  data() {
    return {
      info: {},
      RECIPE_TYPE
    }
  },
  computed: {
    drugList() {
      return this.info.drugList || [];
    },
    onlineShipping() {
      return this.info.onlineShipping || {}
    }
  },
  mounted() {
    this.getInfo()
  },
  methods: {
    init() {
      const appEl = document.getElementById('app');
      appEl.style.overflowY = 'auto';
    },
    dl() {
      window.open(this.info.recipePdfUrl);
    },
    print() {
      const pHTML = this.$refs.print.$el.innerHTML;
      window.document.body.innerHTML = pHTML;
      window.print();
      location.reload();
    },
    async getInfo() {
      this.info = await recipeService.info(this.$route.query.orderId);
      await this.$nextTick();
      this.init();
    }
  },
}
</script>

<style scoped lang="scss">
table {
  width: 100%;
  border-collapse: collapse;
}

td {
  border: 1px solid #000000;
  padding: 5px;
}
</style>
